import { string } from 'yup';

import { DEFAULT_SCHEMA_REQUIRED_MESSAGE, POSTCODE_REGEX } from 'common/constants';

import { validateTelephone } from 'common/lib/telephone';
import { replaceAll } from 'common/lib/utils';

/**
 * Shared validation schema for UK telephone numbers
 */
export const createTelephoneValidationSchema = () =>
  string()
    .default('' as string)
    .required(DEFAULT_SCHEMA_REQUIRED_MESSAGE)
    .test('starts_07', 'Phone number must start with "07".', telephone => {
      if (telephone && telephone.length >= 2) {
        const first2Digits = telephone.substring(0, 2);
        return first2Digits === '07';
      }
      return false;
    })
    .min(11, 'Phone number is too short.')
    .test('valid_phone_number', 'Please enter a valid UK mobile phone number.', async telephone => {
      return validateTelephone(telephone);
    });

/**
 * Shared validation schema for email addresses
 */
export const createEmailValidationSchema = () =>
  string()
    .default('' as string)
    .required(DEFAULT_SCHEMA_REQUIRED_MESSAGE)
    .email('Please enter a valid email address.');

/**
 * Shared validation schema for UK postcodes
 */
export const createPostcodeValidationSchema = (customErrorMessage?: string) =>
  string()
    .strict(false)
    .default('')
    .required(DEFAULT_SCHEMA_REQUIRED_MESSAGE)
    .transform(function (value, _) {
      return this.isType(value) && value !== null ? replaceAll(value, ' ', '') : value;
    })
    .matches(
      POSTCODE_REGEX,
      customErrorMessage ||
        'Please enter a valid UK postcode. You must live in and have the right to work in the UK to join Housekeep.'
    );

/**
 * Shared validation schema for names (first name, last name)
 */
export const createNameValidationSchema = () => string().default('').trim().required(DEFAULT_SCHEMA_REQUIRED_MESSAGE);
